<template>
  <li class="compliance-item">
    <div :class="itemStatusClass" :title="statusName">
    </div>
    <div class="item-name">
      <slot />
    </div>
    <div class="line"></div>
  </li>
</template>
<script>
import complianceItemBase from './ComplianceItemBase.vue'

export default {
  extends: complianceItemBase,
}
</script>
<style>
.compliance-item {
  position: relative;
  font-weight: bold;
  margin: 0 0 .5em 2em;
}

.compliance-item:after {
  position: absolute;
  content: '';
  left: -29px;
  top: 27px;
  width: 2px;
  height: 100%;
  background-color: #dbdde0;
}

/* Connector from the category above down to this (first) item's dot. The
   category's line ends at its own 1em margin (this li's top edge); this
   segment starts there and stops at this item's dot top (34% of this li), so
   both a wrapped category title and a wrapped item title stay connected. */
.compliance-category + .compliance-item:before {
  position: absolute;
  content: '';
  left: -29px;
  top: -1em;
  height: calc(34% + 1em);
  width: 2px;
  background-color: #dbdde0;
}

.item-name{
  padding-top: 10px;
  font-size: 12px;
}

.item-default, .item-incomplete, .item-completed, .item-pending, .item-expired, .item-expiring-soon, .item-opted-out{
  position: absolute;
  top: 34%;
  left: -2.65em;
  border-radius: 50%;
  z-index: 1;
  box-sizing: content-box;
  height: 1em;
  width: 1em;
}

.item-default, .item-incomplete{
  border: 2px solid #dbdde0;
  background-color: #FFF;
}

.item-pending{
  border: 2px solid purple;
  background-color: purple;
}

.item-completed{
  border: 2px solid green;
  background-color: green;
}

.item-expiring-soon{
  border: 2px solid orange;
  background-color: orange;
}

.item-expired{
  border: 2px solid red;
  background-color: red;
}


.item-opted-out{
  border: 2px solid rgb(3, 113, 187);
  background-color: rgb(3, 113, 187);
}

.compliance-item:last-child:after {
  position: absolute;
  content: '';
  left: 0px;
  top: 0px;
  width: 0px;
  height: 0px;
  background-color: var(--complianceTheme);
}


</style>